// NineSliceBox.tsx
import { resolveAsset } from '@/core/utils/common.utils';
import React from 'react';

interface Props {
  image: string;
  slice: number; // Наприклад, 50
  width?: string | number;
  maxWidth?: string | number;
  height?: string | number;
  maxHeight?: string | number;
  padding?: string | number;
  bgColor?: string;
  children: React.ReactNode;
}

interface SecondaryProps {
  className?: string;
  width?: string | number;
  height?: string | number;
  padding?: string | number;
  children: React.ReactNode;
}

export const NineSliceBox = ({ image, slice, width, height, children, padding, maxWidth, maxHeight, bgColor }: Props) => {
  const finalPadding = padding ?? slice;

  return (
    <div style={{
      position: 'relative',
      width: width || 'auto',
      height: height || '50dvh',
      maxWidth: maxWidth || '650px',
      maxHeight: maxHeight || '650px',
      padding: `${finalPadding}px`,
      boxSizing: 'border-box',
      display: 'flex',
      flexDirection: 'column',
    }}>
      
      {/* 1. ШАР ФОНУ (Показується поки вантажиться текстура або як основа) */}
      {bgColor && (
        <div style={{
          position: 'absolute',
          // Вступ (inset) дорівнює розміру слайсу, щоб колір не заліз на прозорі кути
          top: `${slice/2}px`,
          left: `${slice/2}px`,
          right: `${slice/2}px`,
          bottom: `${slice/2}px`,
          backgroundColor: bgColor,
          zIndex: 0 // Має бути під текстурою
        }} />
      )}

      {/* 2. ШАР ТЕКСТУРИ (9-Slice) */}
      <div style={{
        position: 'absolute',
        inset: 0,
        borderStyle: 'solid',
        borderWidth: `${slice}px`,
        borderImageSource: `url("${resolveAsset(image)}")`,
        borderImageSlice: `${slice} fill`,
        borderImageWidth: `${slice}px`,
        borderImageRepeat: 'stretch',
        pointerEvents: 'none',
        borderColor: 'transparent',
        zIndex: 1 // Поверх фонового кольору
      }} />

      {/* 3. КОНТЕНТ */}
      <div style={{
        position: 'relative',
        flex: 1,
        overflowY: 'auto',
        overflowX: 'hidden',
        zIndex: 2 // Поверх усього
      }}>
        <div style={{ position: 'relative' }}>
          {children}
        </div>
      </div>
    </div>
  );
};

export const PergamentBox = ({ children, width, height, className, padding }: SecondaryProps) => (
  <NineSliceBox
    image="@assets/ui/pergamentv.png"
    slice={60}
    padding={padding || 40}
    width={width}
    height={height}
    maxWidth={550}
    maxHeight={650}
    bgColor="#edd6ad"
  >
    <div className={className}>
      {children}
    </div>
  </NineSliceBox>
);

export const LeatherBox = ({ children, width, height, className, padding }: SecondaryProps) => (
  <NineSliceBox
    image="@assets/ui/leather.png"
    slice={80}
    padding={padding || 40}
    width={width}
    height={height}
    bgColor='#7f401d'
  >
    <div className={className}>
      {children}
    </div>
  </NineSliceBox>
);